import { ApolloError, useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import BloodSugarQuery from './BloodSugarQuery';
import { IBloodSugar, IOptimalBloodSugarTarget } from '../types';

type result = {
  loading: boolean;
  error: ApolloError | undefined;
  bloodSugar?: IBloodSugar[];
  optimalBloodSugarTarget?: IOptimalBloodSugarTarget;
};

interface IBloodSugarConnectorApollo {
  children: (result: result) => JSX.Element;
}

const BloodSugarConnectorApollo: React.FC<IBloodSugarConnectorApollo> = ({ children }) => {
  const { loading, error, data } = useQuery(BloodSugarQuery);

  const result: result = {
    loading,
    error,
  };

  if (!loading) {
    result.bloodSugar = data.diabetes.bloodSugarMeasurements.userMeasurements.edges;
    result.optimalBloodSugarTarget =
      data.diabetes?.userDiabetes?.treatment?.optimalBloodSugarTarget;
  }

  return children(result);
};

BloodSugarConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default BloodSugarConnectorApollo;
